//#region libraries
import React, { useEffect } from 'react';
//redux
import { useSelector, useDispatch } from 'react-redux';
import { getQAPairs, postQAPair, deleteQAPair, selectQAPairs, selectQALoading, selectQAError, setAnswer, setQuestion, selectQuestion, selectAnswer } from '_redux/slices/qa/qa';
import { selectIata } from '_redux/slices/main-screen/user';
//firebase
import { onSnapshot, collection } from 'firebase/firestore';
import { firestore } from '_utils/firebase-app';
//tremor
import { Text, TextInput, Button } from '@tremor/react';
//#endregion
const QAPage = () => {
  //#region redux
  const dispatch = useDispatch();
  const iata = useSelector(selectIata);
  const pairs = useSelector(selectQAPairs);
  const loading = useSelector(selectQALoading);
  const error = useSelector(selectQAError);
  const question = useSelector(selectQuestion);
  const answer = useSelector(selectAnswer);
  //#endregion

  //#region useEffect
  useEffect(() => {
    dispatch(getQAPairs(iata));
  }, [dispatch, iata]);

  useEffect(() => {
    let isFirstSnapshot = true; // Flag to check if it's the first snapshot

    const unsubscribe = onSnapshot(
      collection(firestore, `support-desks/${iata}/qa`),
      (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === 'added' || change.type === 'removed') {
            const newMessage = change.doc.data();
            if (!isFirstSnapshot) {
              dispatch(getQAPairs(iata));
            }
          }
        });

        isFirstSnapshot = false; // Update the flag after the first snapshot
      }
    );

    return () => unsubscribe();
  }, []);

  //#endregion

  //#region functions of QA

  const handlePostQAPair = () => {
    dispatch(postQAPair({ airport: iata, question, answer }));
    dispatch(setQuestion(''));
    dispatch(setAnswer(''));
  };

  const handleDeleteQAPair = (pairId, iata) => {
    dispatch(deleteQAPair({ pairId, iata }));
  };
  //#endregion

  return (
    <>
      <Text>Question and Answer Pairs:</Text>
      {loading ? (
        <Text>Loading...</Text>
      ) : error ? (
        <Text>Error: {error}</Text>
      ) : (
        pairs.map((pair) => (
          <div key={pair.id}>
            <Text>Question: {pair.question}</Text>
            <Text>Answer: {pair.answer}</Text>
            <Button onClick={() => {
              handleDeleteQAPair(pair.id, iata)
            }
            }>Delete</Button>
          </div>
        ))
      )}
      <Text>Post a Question and Answer Pair:</Text>
      <TextInput placeholder="Enter question" value={question} onChange={(e) => dispatch(setQuestion(e.target.value))} />
      <TextInput placeholder="Enter answer" value={answer} onChange={(e) => dispatch(setAnswer(e.target.value))} />
      <Button onClick={handlePostQAPair}>Post Pair</Button>
    </>
  );
};

export default QAPage;
